import "../../stylesheets/about-package/about.less";
import "../../stylesheets/shared-package/shared.less";
import "../../stylesheets/contribute-package/contribute.less";

import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {Title} from "@khanacademy/wonder-blocks-typography";
import {RequestInfo} from "@khan/shared-core";
import {mediaQueries, pageWidth} from "@khan/shared-styles";

import PageRoot from "#app-shell-package/page-root.tsx";
import InfoBlock from "#marketing-content-shared-package/info-block.tsx";

import AboutHeader from "./about-header.tsx";
import AboutNav from "./about-nav.tsx";
import LanguageMap from "./language-map.tsx";
import LastChance from "./last-chance.tsx";
import {withStrings} from "./locales/contribute/load-strings.tsx";

type Props = Record<any, any>;

class Contribute extends React.Component<Props> {
    renderContribute(): React.ReactNode {
        return (
            <View style={styles.container}>
                <View style={styles.languageHeader}>
                    <Title>
                        {RequestInfo.kaLocale === "en"
                            ? t`Supporting over ${50} languages and counting`
                            : t`Supporting over 60 languages and counting`}
                    </Title>
                </View>
                <View style={styles.languageMapContainer}>
                    <View style={styles.languageMapInnerContainer}>
                        <LanguageMap />
                    </View>
                </View>
                <InfoBlock
                    kind="InfoBlock"
                    headline={t`Bring Khan Academy to the world`}
                    copy={t`Help us translate our content into the world’s languages.`}
                    cta={{
                        copy: t`Apply to Translate`,
                        url: "https://www.khanacademy.org/r/applytotranslate",
                        type: "button",
                    }}
                    align="right"
                    staticGraphic="/images/about/language_map/translate.jpg"
                />
                <LastChance
                    headline={t`Learn more`}
                    backgroundUrl="/images/about/language_map/links-background.jpg"
                    ctas={[
                        {
                            kind: "link",
                            copy: t`International Blog`,
                            href: "https://international.khanacademy.org/",
                        },
                        {
                            kind: "link",
                            copy: t`Contributor Credits`,
                            href: "/contribute/credits",
                        },
                        {
                            kind: "link",
                            copy: t`Translator Help Desk`,
                            href: "https://khanacademy.zendesk.com/hc/en-us/categories/200186020-Translators",
                        },
                    ]}
                />
            </View>
        );
    }

    render(): React.ReactNode {
        return (
            <PageRoot settings={{title: t`Translators`}}>
                <div className="about-page">
                    <AboutHeader
                        pageheadline={t`Global Learning, Global Impact.`}
                        headercontent={
                            <a
                                href="https://www.khanacademy.org/r/applytotranslate"
                                className="apply-button"
                            >
                                {t`Apply to translate`}
                            </a>
                        }
                    />
                    <AboutNav aboutSelection="contribute" />
                    {this.renderContribute()}
                </div>
            </PageRoot>
        );
    }
}

export default withStrings(Contribute);

const styles = StyleSheet.create({
    container: {
        backgroundColor: color.white,
    },

    languageHeader: {
        textAlign: "center",
        marginTop: 16,
        marginBottom: 16,
    },

    languageMapInnerContainer: {
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    },
    languageMapContainer: {
        margin: "auto",
        marginBottom: 100,
        width: "100%",
        maxWidth: pageWidth,
        padding: "0 64px",

        [mediaQueries.mdOrSmaller]: {
            maxWidth: "inherit",
            paddingLeft: 20,
            paddingRight: 20,
        },
    },
});
